import { AuthGuardService } from './../auth-guard.service';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PolicyDetailsStepFormComponent } from './policy-details-step-form/policy-details-step-form.component';
import { PolicyListingSearchComponent } from './policy-listing-search/policy-listing-search.component';
import { PremiumDueSearchComponent } from './premium-due-search/premium-due-search.component';
import { PremiumPaidHistorySearchComponent } from './premium-paid-history-search/premium-paid-history-search.component';
import { ProposalListingSearchComponent } from './proposal-listing-search/proposal-listing-search.component';
import { MyPoliciesSearchComponent } from './my-policies-search/my-policies-search.component';
import { MyCustomersSearchComponent } from './my-customers-search/my-customers-search.component';
const routes: Routes = [
  {
    path: 'policy',
    component: PolicyDetailsStepFormComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'policy/:id',
    component: PolicyDetailsStepFormComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'search-policy-listing',
    component: PolicyListingSearchComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'search-premium-due',
    component: PremiumDueSearchComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'search-premium-paid-history',
    component: PremiumPaidHistorySearchComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'search-proposal-listing',
    component: ProposalListingSearchComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'search-my-policies',
    component: MyPoliciesSearchComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'search-my-customers',
    component: MyCustomersSearchComponent,
    canActivate: [AuthGuardService],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],

  exports: [RouterModule],
})
export class PolicyDetailsRoutingModule {}
